<template>
    <div class="vm-tag nowrap">
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: 'tag',
    props: {
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style lang="stylus" scoped>
.vm-tag{
    display inline-flex
    background-color $orange
    color $white
    font-size 12px;
    padding px2rem(1) px2rem(6.5)
    border-radius px2rem(2)
    &.size2{
      padding 2px 6px;
    }
    &.tiny{
      font-size 16px;
      transform: scale(.5);
      transform-origin: left center;
      padding 6px 8px;
    }

    &.gray{
        color $black-5;
        background: $gray;
    }
    &.gray2{
        color $black;
        background: $gray;
    }
    &.cyan{
        background-color $cyan
    }
    &.purple{
        background-color $purple
    }
    &.circle{
        border-radius: 1000px;
        line-height: normal;
    }
    &.red-6{
        color $red-6
        background-color $red-1
    }
    &.white{
      background-color $white;
      color $black;
      border:1px solid $black-1;
    }
}
</style>
